import type { SignInIdentifier } from '@logto/schemas';
import { useContext } from 'react';

import UserInteractionContext from '@/Providers/UserInteractionContextProvider/UserInteractionContext';
import { useTranslation } from 'react-i18next';
import useNavigateWithPreservedSearchParams from '@/hooks/use-navigate-with-preserved-search-params';
import { UserFlow } from '@/types';

type Props = {
  readonly identifier?: SignInIdentifier;
  readonly value?: string;
  readonly className?: string;
};

const ForgotPasswordLink = ({ className, ...identifierData }: Props) => {
  const {t}=useTranslation();
  const navigate = useNavigateWithPreservedSearchParams();
  const { setForgotPasswordIdentifierInputValue } = useContext(UserInteractionContext);

  return (
    <button type="button"
      className={className}
      onClick={() => {
        setForgotPasswordIdentifierInputValue({
          type: identifierData.identifier,
          value: identifierData.value ?? '',
        });

        navigate(`/${UserFlow.ForgotPassword}`);
      }}
    >{t("action.forgot_password")}</button>
  );
};

export default ForgotPasswordLink;
